// extracted by mini-css-extract-plugin
module.exports =  {"root":"dpF_TIGNn7mwurmvFT5N","content":"vBTQxicL8aBAgzGXGla1"};